"use strict";
/**
 * Markets Selectors
 * Helper functions to select specific markets from lists
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarketAlphabetically = getMarketAlphabetically;
/**
 * Get market alphabetically (first by ticker)
 */
function getMarketAlphabetically(markets) {
    if (!markets?.length) {
        return undefined;
    }
    return markets.sort((a, b) => a.ticker.localeCompare(b.ticker))[0];
}
